import { FC, useState } from 'react';

import { SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';
import Link from 'next/link';
import { Button } from '../../../components/button/button';
import styles from './credits-block.module.css';
import { Modal } from '../../../components/modal/modal';

type Props = {
    hasSubscription: boolean
    creditPacks?: SubscriptionPackage[]
};

export const CreditsBlock: FC<Props> = ({ creditPacks, hasSubscription }) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const handleViewPlans = () => {
        setModalOpen(false);
        document.querySelector('#main')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };

    return (
        <div className={styles['credits-block']}>
            <div className={styles['credits-block__description']}>
                <h3>Credit Packs</h3>
                <p>Not enough credits in your plan? You can purchase a fixed amount of credits if you need more than your monthly subscription provides.</p>
            </div>

            <ul className={styles['packs-list']}>
                {creditPacks?.map((creditPack) => (
                    <li className={styles['packs-list__item']} key={creditPack.id}>
                        <p>{creditPack.amount_of_credits} Credits</p>
                        <p>
                            ${creditPack.amount}{' '}
                            <span className={styles['packs-list__calc']}>
                                (${(Number(creditPack.amount) / Number(creditPack.amount_of_credits)).toFixed(3)} per credit)
                            </span>
                        </p>
                        <p className={styles['packs-list__button']}>
                            {hasSubscription ? (
                                <Link href={`./plan/buy-credits/${creditPack.id}`} passHref>
                                    <Button as="a">
                                        Add Credits
                                    </Button>
                                </Link>
                            ) : (
                                <Button type="button" onClick={() => setModalOpen(true)}>
                                    Subscription Required
                                </Button>
                            )}
                        </p>
                    </li>
                ))}
            </ul>

            <Modal
                title="You Need an Active Plan to Add Credits"
                description="Choose your monthly subscription plan first, then you can add more credits at any time."
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                buttons={(
                    <Button
                        type="button"
                        onClick={handleViewPlans}
                        variant="primary"
                        className={styles['modal-button']}
                    >
                        View Plans
                    </Button>
                )}
            />
        </div>
    );
};
